// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  Headers
 */
/*
  Base Sizing
 */
/*
  Colors
 */
/*
  Border Radii Sizes
 */
/*
  Shadows
 */
/*
  Global Styles
 */
html {
  font-size: 10px;
}

/**
 * COODE Header Colors
 */
.linked-budget-request-form__empty-error .pui-loader-error__message {
  font-size: 16px;
  color: #adadad;
}
.linked-budget-request-form__breadcrumb {
  margin-bottom: 32px;
}
.linked-budget-request-form__breadcrumb .pui-breadcrumb .pui-breadcrumb-item span {
  color: #4a4a4a;
}
.linked-budget-request-form__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 32px;
}
.linked-budget-request-form__header__title {
  color: #4a4a4a;
}
.linked-budget-request-form__header__actions {
  display: flex;
  gap: 10px;
}
.linked-budget-request-form__inline-notification {
  margin-bottom: 16px;
}
.linked-budget-request-form__inline-notification .pui-form-inline-notification__message__title {
  font-weight: bold;
}
.linked-budget-request-form__inline-notification .pui-form-inline-notification__close {
  display: none;
}
.linked-budget-request-form__chip-list {
  margin-right: 4px;
}
.linked-budget-request-form .pui-chip__text {
  display: flex;
}
.linked-budget-request-form__global-id-type-ahead {
  width: 100%;
}
.linked-budget-request-form__global-id-type-ahead .pui-form-type-ahead-input-async-multi-select__search-input-wrap {
  display: flex;
}
.linked-budget-request-form__global-id-type-ahead .unremovable-chip .pui-chip--removable {
  padding: 5px 12px;
}
.linked-budget-request-form__global-id-type-ahead .unremovable-chip .pui-chip__remove-icon {
  display: none;
  padding: 0;
}
.linked-budget-request-form .pui-collapsible__header {
  font-weight: bold;
}
.linked-budget-request-form__container {
  padding: 0 20px 20px;
}
.linked-budget-request-form__container__section-margin-top {
  margin-top: 24px;
}
.linked-budget-request-form__headline .pui-headline {
  text-transform: uppercase;
  font-weight: bold;
  color: #4a4a4a;
  margin-bottom: 16px;
}
.linked-budget-request-form__scrollable-row {
  display: flex;
  overflow: auto;
  padding-bottom: 32px;
}
.linked-budget-request-form__scrollable-row .pui-grid-col {
  min-width: 200px;
}
.linked-budget-request-form__separator {
  border-color: #adadad;
  margin: 40px 0 16px 0;
}
.linked-budget-request-form__separator--equal {
  margin: 16px 0 16px 0;
}
.linked-budget-request-form .pui-form-input-selector .pui-form-input-selector__option label {
  width: 100%;
}
.linked-budget-request-form__input-with-icon {
  display: flex;
  align-items: center;
}
.linked-budget-request-form__input-with-icon .pui-form-input-field, .linked-budget-request-form__input-with-icon .pui-form-type-ahead-input-async-multi-select {
  border-radius: 4px 0 0 4px;
  border-right-width: 0;
}
.linked-budget-request-form__input-with-icon__icon {
  min-width: 40px;
  height: 40px;
  background-color: #0078dc;
  border-radius: 0 4px 4px 0;
  color: #ffffff;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
}
.linked-budget-request-form__input-with-icon__icon--informative {
  background-color: #607D8B;
}
.linked-budget-request-form__input-with-icon__icon--currency {
  background-color: #607D8B;
  min-width: 50px;
}
.linked-budget-request-form__input-with-icon__icon--currency__headline {
  font-size: 12px;
}
.linked-budget-request-form__input-with-icon__icon .pui-button {
  border-radius: 0 4px 4px 0;
}
.linked-budget-request-form__input-with-icon__icon__headline {
  margin: 0;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
